export const systemApiURl = {
  config: "/system/config",
};
